module.exports = __webpack_public_path__ + "static/1418adb2e2c4e36df7b58bd31abe28fd25649a9808af5bf3b5e7487dedbec5c9-803be6eb0bbfb18785b44eb0a058dc10.png";